import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, NavigationType } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { gethome, eventperson, getsystemlis } from '../../utils/api'
import debounce from '../../utils/debounce'
import { Loader } from '@googlemaps/js-api-loader';
import axios from "axios";
import { InfiniteScroll } from 'antd-mobile'
import { divide } from 'lodash';
import { gettime3 } from '../../utils/time'
import { key } from './key'

const world = {
  color: '#AE9EFF',
  backgroundColor: '#302F43',
  fontSize: '12px',
  borderRadius: '30px',
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 18,
  paddingRight: 18,
  margin: '5px',
  marginRight: '5px',
  marginLeft: 0,
  cursor: 'pointer'
  , height: '36px'
  , lineHeight: '16px'
}

const world2 = {
  color: '#fff',
  backgroundColor: '#35363B',
  fontSize: '12px',
  borderRadius: '30px',
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 18,
  paddingRight: 18,
  margin: '5px',
  marginLeft: 0,
  marginRight: '5px',
  cursor: 'pointer', height: '36px', lineHeight: '16px'
}



const Search: React.FC = () => {
  const { t } = useTranslation()
  const [upcoming, getupcoming] = useState([]) as any;
  let upcomingRef = useRef([]) as any;


  const city2 = ["Worldwide", "United States"]
  const goBackPage = () => {
    window.history.back()

  }
  const [city, setcity] = useState([]) as any
  const [val, setval] = useState('')
  const [show, setshow] = useState(false)
  const [country, getcountry] = useState(localStorage.getItem('country')) as any
  let countryRef = useRef('');
  useEffect(() => {
    countryRef.current = country
  }, [country])


  const [country3, getcountry2] = useState(localStorage.getItem('country')) as any



  let [num, setNum] = useState(0)
  let Numref = useRef(num);

  useEffect(() => {
    Numref.current = num
  }, [num])



  let [total, settotal] = useState(0)
  let totalref = useRef(total);
  useEffect(() => {
    totalref.current = total
  }, [total])

  let [keywords, setkeywords] = useState('')

  let keywordRref = useRef(keywords);
  useEffect(() => {
    keywordRref.current = keywords
  }, [keywords])


  const inputval = debounce(() => {
    settotal(0)
    upcomingRef.current = []
    getupcoming(upcomingRef.current)
    Numref.current = 0
    keywordRref.current = val
    setkeywords(keywordRref.current)
  
      getDate()
    
 
    if(countryRef.current=='China'){
      console.log(11111)
      getDate2()
    }
  }, 2000, setval)

  const handleMapClick = async (pos: any) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${key}&language=en-US`
      );

      countryRef.current = response.data.results[response.data.results.length - 1].formatted_address
      getcountry(countryRef.current)
      const countrys = response.data.results[response.data.results.length - 1].formatted_address
      getDate()
    } catch (error) {
      console.error(error);
    }
  }

  let [Selected, setSelected] = useState('') as any;

  let SelectedRef = useRef('') as any;
  useEffect(() => {
    SelectedRef.current = Selected
  }, [Selected])


  const Getactivities = (country: string, country2: string | null,) => {

    settotal(0)
    if (country == SelectedRef.current) {
      countryRef.current = country2?country3:''
      getcountry(countryRef.current)
      upcomingRef.current = []
      getupcoming(upcomingRef.current)
      Numref.current = 0
      SelectedRef.current = ''
      setSelected(SelectedRef.current)
      if(keywordRref.current){
        getDate()
      }
    } else {

  

      if (country == 'Worldwide') {
        countryRef.current = ''
        getcountry(countryRef.current)
        upcomingRef.current = []
        getupcoming(upcomingRef.current)
        Numref.current = 0
        SelectedRef.current = country
        setSelected(SelectedRef.current)
        getDate()
      } else {
        countryRef.current = country
        getcountry(countryRef.current)
        upcomingRef.current = []
        getupcoming(upcomingRef.current)
        Numref.current = 0
        SelectedRef.current = country
        setSelected(SelectedRef.current)
        getDate()
        if(countryRef.current=='China'){
          console.log(11111)
          getDate2()
        }
      }
    }


  }

  const getpositioning = (country: string | null) => {
    SelectedRef.current = country
    setSelected(SelectedRef.current)
    upcomingRef.current = []
    getupcoming(upcomingRef.current)
    Numref.current = 0
    const loader = new Loader({
      apiKey: key,
      version: 'weekly',
      language: 'en-US'
    });

    loader.load().then(() => {
      // Try HTML5 geolocation.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            console.log(pos, 'Longitude and latitude')
            handleMapClick(pos)
          },
          () => {

          }
        );
      } else {
        // Browser doesn't support Geolocation
      }

    });
  }



  const geif = () => {
    const data: any = []
    let data2: any = []
    data2 = localStorage.getItem('getMyContacts')
    data2 = JSON.parse(data2)
    let Frienddata = data2 ? data2 : []
    Frienddata.forEach((item: any) => {
      data.push(item.userId)
    })

    return data
  }

  const [showhasMore, setshowhasMore] = useState(false)
  const getDate = async () => {
    setshowhasMore(true)
    setHasMore(true)
    let pageSize = 10
    Numref.current = Numref.current + 1
    setNum(Numref.current)
    await gethome({
      eventCountry: countryRef.current,
      keywords: keywordRref.current,
      // state: myRef.current,
      // pageNum: Numref.current,
      current: Numref.current,
      pageSize: pageSize
    }).then((res) => {

      let data = geif()
      settotal(res.total)
      if (res.rows.length > 0) {
        res.rows.forEach((item: any, index: any) => {
          item.time = gettime3(item.eventStartTime, item.eventEndTime)
          item.sdmUsers.forEach((i: any) => {
            i.c = color16()
            i.imgUrl = i.imgUrl + ''
          })

          item.people = 0
          eventperson({
            linUserIds: data,
            eventId: item.eventId
          }).then((re) => {


            // if (re.data) {
            if (re.data) {
              item.people = re.data.friends
            }

            if (index == res.rows.length - 1) {
              let tmp = upcomingRef.current
              tmp.push(...res.rows)
              tmp.forEach((item: any) => {
                item.eventBanner = item.eventBanner.replace('http:', 'https:')
                if (item.sdmUsers[0])
                  item.sdmUsers.forEach((item2 :any) => {
                    if (item2.imgUrl == undefined || item2.imgUrl == null || item2.imgUrl == 'null' || item2.imgUrl == 'undefined')
                      item2.imgUrl = ''
                  })
              })
              getupcoming([...tmp])
              console.log(upcoming, '3')
              setHasMore(true)
              setshowhasMore(false)
              if (res.total > upcomingRef.current.length) {
                setHasMore(true)
              } else {
                setHasMore(false)
              }
            }
          }
            // }
          );
        });
      } else {
        setHasMore(false)
        return false
      }
    }
    );
  }

  const getDate2 = async () => {
    setshowhasMore(true)
    setHasMore(true)
    let pageSize = 10
    Numref.current = Numref.current 
    setNum(Numref.current)
    await gethome({
      eventCountry: '中国',
      keywords: keywordRref.current,
      current: Numref.current,
      pageSize: pageSize
    }).then((res) => {

      let data = geif()
      settotal(res.total)
      if (res.rows.length > 0) {
        res.rows.forEach((item: any, index: any) => {
          item.time = gettime3(item.eventStartTime, item.eventEndTime)
          item.sdmUsers.forEach((i: any) => {
            i.c = color16()
            i.imgUrl = i.imgUrl + ''
          })

          item.people = 0
          eventperson({
            linUserIds: data,
            eventId: item.eventId
          }).then((re) => {


            // if (re.data) {
            if (re.data) {
              item.people = re.data.friends
            }

            if (index == res.rows.length - 1) {
              let tmp = upcomingRef.current
              tmp.push(...res.rows)
              tmp.forEach((item: any) => {
                item.eventBanner = item.eventBanner.replace('http:', 'https:')
              })
              getupcoming([...tmp])
              console.log(upcoming, '3')
              setHasMore(true)
              setshowhasMore(false)
              if (res.total > upcomingRef.current.length) {
                setHasMore(true)
              } else {
                setHasMore(false)
              }
            }
          }
            // }
          );
        });
      } else {
        setHasMore(false)
        return false
      }
    }
    );
  }


  const color16 = () => {
    var r = Math.floor(Math.random() * 256);
    var g = Math.floor(Math.random() * 256);
    var b = Math.floor(Math.random() * 256);
    // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
    var color = 'rgb(' + r + ',' + g + ', ' + b + ')';
    return color
  }




  const scrollEvent = debounces(() => {
    let html = document.documentElement || document.body
    if (html.scrollTop >= html.scrollHeight - html.clientHeight - 100) {
      // if (val != '' && upcomingRef.current.length > 9) {
      //   getDate(val)
      // }
      if (totalref.current > upcomingRef.current.length) {
        getDate()
        if(countryRef.current=='China'){
          console.log(11111)
          getDate2()
        }
        // debounce(getDate, 500)
      } else {
        setHasMore(false)
      }
    }
  }, 500)

  const [hasMore, setHasMore] = useState(true)
  async function loadMore() {

  }

  const setRegion = async () => {
    await getsystemlis('sys_location_selection').then((res) => {
      setcity(res.data)

    })
  }

  function debounces(func: any, wait: any) {
    var timeout: any;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };

  }

  useEffect(() => {

    window.scrollTo(0, 0);
    setRegion()
    document.addEventListener('scroll', scrollEvent)
    return () => {
      document.removeEventListener('scroll', scrollEvent);
    };
  }, []);

  return <div style={{ backgroundColor: '#202225' }}>
    <div style={{ display: 'flex', padding: '20px', cursor: 'pointer' }}>

      <div style={{ position: 'relative' }}>
        <img src={require("../../static/img/Search.png")} style={{ width: '22px', height: '22px', alignSelf: 'center', position: 'absolute', left: '20px', top: '10px' }} ></img>
        <input type="text" value={val} onChange={(e) => inputval(e)}
          style={{
            width: '70vw', height: '40px', backgroundColor: '#000000', borderRadius: 5, display: 'flex',
            color: '#fff', lineHeight: '40px', marginLeft: 10, fontSize: '14px', border: 'none', paddingLeft: '40px'
          }} placeholder='search' />
      </div>
      <div style={{ color: '#BABBBE', marginLeft: 20, lineHeight: '40px', width: '45px', textAlign: 'center' }} onClick={() => goBackPage()}>{t('Cancel')}
      </div>
    </div>
    <div style={{ marginLeft: '20px', marginRight: '20px', color: '#999999' }}>
      {t('Popularcities')}
      <div style={{
        display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '5px'
      }}>



        {
          city.length > 0 ? <div style={{
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '5px', cursor: 'pointer'
          }}>
            <div style={SelectedRef.current == 'Locate' ? world : world2} onClick={() => getpositioning('Locate')}>
              {t('Locate')}
              {
                SelectedRef.current == 'Locate' ? <img src={require("../../static/img/dw1.png")} style={{ width: '14px', height: '14px', marginLeft: '5px' }} ></img> :
                  <img src={require("../../static/img/dw.png")} style={{ width: '14px', height: '14px', marginLeft: '5px' }} ></img>
              }

            </div>
            {city.map((item: any, index: number) =>
              <div key={index} onClick={() => Getactivities(item.dictValue, item.dictLabel)}>
                <div style={item.dictValue == SelectedRef.current ? world : world2}>
                  {item.dictValue}
                  {item.dictValue == 'Locate' && <img src={require("../../static/img/Vector3.png")} style={{ width: '14px', height: '14px', marginLeft: '5px' }} ></img>}
                </div>
              </div>
            )}
          </div> : <div style={{
            display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginTop: '5px'
          }}>  <div style={SelectedRef.current == 'Locate' ? world : world2} onClick={() => getpositioning('Locate')}>
              {t('Locate')}
              <img src={require("../../static/img/Vector3.png")} style={{ width: '14px', height: '14px', marginLeft: '5px' }} ></img>
            </div>{city2.map((item: any, index: number) =>
              <div key={index} onClick={() => Getactivities(item, item)}>
                <div style={item == SelectedRef.current ? world : world2}>
                  {item}
                  {item == 'Locate' && <img src={require("../../static/img/Vector3.png")} style={{ width: '14px', height: '14px', marginLeft: '5px' }} ></img>}
                </div>
              </div>
            )}</div>

        }



      </div>

    </div>
    <div>
      {total != 0 && <div style={{ paddingTop: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', height: '16px', margin: '20px', marginTop: '10px' }}>
          <div style={{ fontSize: '16px', fontWeight: 700, lineHeight: '16px', color: '#FFF', marginRight: '5px' }}>{total}</div>
          <div style={{ fontSize: '14px', fontWeight: 400, lineHeight: '16px', color: '#FFF' }}>{t('events')}:</div>
        </div>

        {
          upcoming.map((item: any, index: any) => <div>
            {total >= index + 1 &&
              <Link to={`/eventdetails?eventId=${item.eventId}&country=${country}`
                // `/eventdetails?eventId=${item.eventId}`
              }
                style={{ color: '#FFF', textDecorationLine: 'none' }}
                key={index}
              >
                <div style={{
                  backgroundColor: '#202225',
                  alignItems: 'center',
                  // position: 'relative',
                  borderRadius: '20px',
                  padding: '20px',
                  paddingTop: 0
                }}>
                  <div style={{
                    width: '100%',
                    borderRadius: '20px',
                    backgroundColor: '#35363B',
                    position: 'relative',
                  }}>
                    <div style={{ height: '100px', overflow: 'hidden', }}>
                      <img src={item.eventBanner} style={{
                        width: '100%',
                        height: '100%',
                        borderTopRightRadius: '20px',
                        borderTopLeftRadius: '20px',
                      }} alt="" />
                    </div>
                    {item.sideNumber != 0 &&

                      <div style={{
                        display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                        borderRadius: '30px', justifyContent: 'center', position: 'absolute', right: '10px', top: '8px', paddingLeft: '8px', paddingRight: '10px', alignItems: 'center'
                      }}>
                        <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                          width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                        }} alt="" />
                        {item.sideNumber} {t('Sideevents')}
                      </div>
                    }

                    <div style={{ margin: 10 }}>
                      {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                      <div style={{ fontSize: '24px', fontWeight: 700, padding: '5px', marginBottom: '5px', overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap', width: '95%' }}>{item.eventName}</div>
                      <div style={{
                        color: '#8E929D',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                      }}>
                        <img src={require("../../static/img/Date.png")} style={{
                          marginLeft: '5px',
                          marginRight: '5px',
                          width: '14px',
                          height: '14px'
                        }}></img> {item.time}
                        {/* {t('6November-7November')} */}
                      </div>
                      <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                        style={{ color: '#FFF', textDecorationLine: 'none' }}
                      >
                        <div style={{
                          color: '#8E929D',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                          paddingTop: '5px'
                        }}>
                          <img src={require("../../static/img/tdesign_location.png")} style={{
                            marginLeft: '5px',
                            marginRight: '5px',
                            width: '14px',
                            height: '14px',

                          }}></img>  <span style={{ width: '85%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{item.eventLocation}</span>
                          {/* {t('NewYork,UnitedStates')} */}
                        </div>
                      </Link>
                    </div>
                    {/* <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                      <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', position: 'relative', width: '80px', height: '24px' }}>
                          <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                            width: '24px',
                            height: '24px',
                            alignSelf: 'center',
                          }} alt="" />

                          <img src={require("../../static/img/7.png")} style={{
                            width: '24px',
                            height: '24px', position: 'absolute', left: 12, alignSelf: 'center',
                          }}></img>
                          <img src={require("../../static/img/8.png")} style={{
                            width: '24px',
                            height: '24px', position: 'absolute', left: 24, alignSelf: 'center',
                          }}></img>
                          <img src={require("../../static/img/9.png")} style={{
                            width: '24px',
                            height: '24px', position: 'absolute', left: 36, alignSelf: 'center',
                          }}></img>
                          <img src={require("../../static/img/Group.png")} style={{
                            width: '24px',
                            height: '24px', position: 'absolute', left: 48, alignSelf: 'center',
                          }}></img>
                        </div>
                        {
                          item.people != 0 &&  <div style={{marginTop:'5px'}}>
                            {item.people} {t('friendswillgo')}
                          </div>

                        }

                      </div>
                      <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                        <img src={require("../../static/img/Vector2.png")} style={{
                          width: '24px',
                          height: '24px', marginRight: 5
                        }} ></img>
                        {item.eventNumber}
                      </div>
                    </div> */}
                    <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                      <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                          {item.sdmUsers.map((item2: any, index: number) => <div>
                            {
                              index < 4 && <div>
                                {
                                  item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index} style={{
                                    width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px', border: '2px solid #2F3039', position: 'absolute'
                                    , left: index * 14,
                                  }} alt="" /> :
                                    <div key={index} style={{
                                      width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px', position: 'absolute', left: index * 14, textAlign: 'center',
                                      backgroundColor: item2.c, color: '#fff', fontSize: '16px', border: '2px solid #2F3039'
                                    }} >{item2.sdmUserName != null ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                }

                              </div>
                            }


                            {
                              index == 4 && <img src={require("../../static/img/Group.png")} key={index} style={{
                                width: '24px', height: '24px', position: 'absolute', left: 56,
                                alignSelf: 'center', borderRadius: '12px'
                              }}></img>
                            }
                          </div>
                          )}
                        </div>
                        {/* {item.people > 0 &&
                          <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px' }}>
                            {item.people}{t('friendswillgo')}
                          </div>
                        } */}

                      </div>
                      {item.people > 0 &&
                        <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                          <span style={{ marginRight: '5px' }}> {item.people}</span>{t('friendswillgo')}
                        </div>
                      }
                      <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                        <img src={require("../../static/img/Vector2.png")} style={{
                          width: '12.5px',
                          height: '20px', marginRight: '5px'
                        }} ></img>
                        {item.eventNumber ? item.eventNumber : 0}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            }
          </div>

          )
        }
      </div>
      }
    </div>



    {
      val ? <div style={{ backgroundColor: '#202225' }}>
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
      </div> : <div> {
        SelectedRef.current && <div style={{ backgroundColor: '#202225' }}>
          <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
      }</div>
    }


  </div >
};

export default Search;